<template>
    <Page :header="header[lang_].name">
        <template v-slot:body>
            <CreateBill />
        </template>
    </Page> 
</template>
  
<script>
import CreateBill from '@/components/personal/bill/Create.vue'
import Page from '@/components/sides/Page.vue' 
import Helper from '@/assets/js/Helper'

export default {
    data() {
        return {
            header: {
                en: {name: "Create a bill"} ,
                ru: {name: "Создать счет"} ,
            }, 
        }
    },
    components: {
        CreateBill,
        Page
    },
    computed: {
        lang_() {return (this.$i18n.locale) ? this.$i18n.locale : 'ru'},
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
    },
    beforeCreate() {
        this.helper = new Helper()
    },
    mounted() {
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        this.helper.SetTgAppBackButton(false)
    },
}
</script>